// Thème Pawely : menu, carrousels, ajout au panier, filtres du catalogue, coloris et galerie produit.
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const currency = (window.Pawely && Pawely.currency) || "EUR";
  const money = cents => new Intl.NumberFormat("fr-FR", { style: "currency", currency }).format(cents / 100);
  // « Rouge rosé » -> « rouge-rose » : sert à reconnaître les photos d'une couleur par leur nom de fichier
  const slug = s => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

  /* ---------- Menu mobile ---------- */
  const burger = $(".burger"), nav = $("#nav");
  if (burger && nav) {
    burger.addEventListener("click", () => burger.setAttribute("aria-expanded", nav.classList.toggle("open")));
    addEventListener("resize", () => { if (innerWidth > 749) { nav.classList.remove("open"); burger.setAttribute("aria-expanded", "false"); } });
  }

  /* ---------- Notification ---------- */
  function toast(msg, link) {
    const t = $(".toast");
    if (!t) return;
    t.innerHTML = "";
    const span = document.createElement("span");
    span.textContent = msg;
    t.append(span);
    if (link) {
      const a = document.createElement("a");
      a.href = link.href;
      a.textContent = link.label;
      t.append(a);
    }
    t.classList.add("show");
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove("show"), link ? 3500 : 2500);
  }

  /* ---------- Panier ---------- */
  function updateCount(n) {
    const c = $(".cart-count");
    if (!c) return;
    c.textContent = n;
    c.hidden = !n;
    c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump");
  }
  async function addToCart(id, quantity = 1) {
    const res = await fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || "Ajout impossible");
    const cart = await (await fetch(root + "cart.js")).json();
    updateCount(cart.item_count);
  }
  const cartUrl = (window.Pawely && Pawely.cartUrl) || root + "cart";

  /* ---------- Carrousels (cartes et page produit) ---------- */
  const visible = media => [...$(".track", media).children].filter(s => !s.hidden);
  function show(media, i) {
    const slides = visible(media), n = slides.length;
    if (!n) return;
    i = (i + n) % n;
    media.dataset.i = i;
    $(".track", media).style.transform = `translateX(${-i * 100}%)`;
    $$(".dots i", media).forEach((d, k) => d.classList.toggle("on", k === i));
    media.dispatchEvent(new CustomEvent("slide", { detail: i }));
  }
  const go = (media, dir) => show(media, (+media.dataset.i || 0) + dir);

  // Glissement au doigt
  let drag = null, swiped = false;
  document.addEventListener("pointerdown", e => {
    const media = e.target.closest(".media");
    if (!media || e.pointerType === "mouse" || visible(media).length < 2) return;
    drag = { media, x: e.clientX, y: e.clientY, dx: 0, on: false };
  });
  addEventListener("pointermove", e => {
    if (!drag) return;
    drag.dx = e.clientX - drag.x;
    if (!drag.on && Math.abs(drag.dx) > 8 && Math.abs(drag.dx) > Math.abs(e.clientY - drag.y)) {
      drag.on = true;
      $(".track", drag.media).classList.add("drag");
    }
    if (drag.on) $(".track", drag.media).style.transform = `translateX(calc(${-(+drag.media.dataset.i || 0) * 100}% + ${drag.dx}px))`;
  });
  const endDrag = () => {
    if (!drag) return;
    const { media, dx, on } = drag;
    drag = null;
    if (!on) return;
    swiped = true;
    setTimeout(() => (swiped = false), 60);
    $(".track", media).classList.remove("drag");
    go(media, Math.abs(dx) > media.clientWidth * 0.2 ? (dx < 0 ? 1 : -1) : 0);
  };
  addEventListener("pointerup", endDrag);
  addEventListener("pointercancel", endDrag);

  document.addEventListener("click", async e => {
    if (swiped && e.target.closest(".media")) { e.preventDefault(); return; }
    const arrow = e.target.closest(".arrow");
    if (arrow) {
      e.preventDefault();
      go(arrow.closest(".media"), arrow.classList.contains("next") ? 1 : -1);
      return;
    }
    // Bouton panier des cartes (produits à une seule couleur)
    const add = e.target.closest("[data-add]");
    if (add) {
      e.preventDefault();
      if (add.getAttribute("aria-disabled") === "true") return;
      try {
        await addToCart(add.dataset.add, 1);
        toast("Dans le panier : " + add.dataset.title, { href: cartUrl, label: "Voir le panier" });
      } catch (err) {
        toast(err.message);
      }
    }
  });

  /* ---------- Catalogue : filtre Chat / Chien, tri, taille de grille ---------- */
  const chips = $("[data-chips]"), grid = $("#grid");
  if (chips && grid) {
    const apply = kind => {
      let n = 0;
      $$(".card", grid).forEach(c => {
        const ok = !kind || c.dataset.tags.split(",").map(s => s.trim()).includes(kind);
        c.hidden = !ok;
        if (ok) n++;
      });
      $("[data-empty]", grid).hidden = n > 0;
      $$(".chip", chips).forEach(c => {
        const on = c.dataset.kind === kind;
        c.classList.toggle("on", on);
        c.setAttribute("aria-checked", on);
      });
    };
    chips.addEventListener("click", e => {
      const c = e.target.closest(".chip");
      if (c) apply(c.dataset.kind);
    });
    // Lien « collections/all#chat » depuis l'accueil
    const fromHash = { chat: "Chat", chien: "Chien" }[location.hash.slice(1).toLowerCase()];
    if (fromHash) apply(fromHash);
  }
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => {
    const url = new URL(location.href);
    url.searchParams.set("sort_by", sort.value);
    location.href = url.toString();
  });
  $$(".cols button").forEach(b => b.addEventListener("click", () => {
    $$(".cols button").forEach(x => x.classList.toggle("on", x === b));
    if (grid) grid.classList.toggle("dense", b.dataset.cols === "dense");
  }));

  /* ---------- Page produit ---------- */
  const pp = $("[data-product]");
  if (pp) {
    const product = JSON.parse($("[data-product-json]", pp).textContent);
    const form = $("[data-product-form]", pp);
    const media = $(".pdp-media", pp);
    const allSlides = media ? $$(".slide", media) : [];
    const thumbs = $$(".thumb", pp);
    const idInput = form && $("[name=id]", form);
    const qtyInput = form && $("[name=quantity]", form);
    const colorIndex = pp.dataset.colorIndex === "" ? -1 : Number(pp.dataset.colorIndex);
    let qty = 1;

    const chosen = () => $$(".swatches", pp).map(f => ($("input:checked", f) || {}).value);
    const currentVariant = () => {
      const opts = chosen();
      return product.variants.find(v => v.options.every((o, k) => opts[k] === undefined || o === opts[k])) || product.variants[0];
    };

    // N'affiche que les photos de la couleur choisie (nom de fichier « couleur-<nom>-… » ou texte alternatif)
    function filterMedia(color) {
      if (!media) return;
      // « couleur-bleu-1 » mais pas « couleur-bleu-clair-1 »
      const key = new RegExp("couleur-" + slug(color) + "-[0-9]");
      const match = allSlides.filter(s => key.test(s.dataset.file) || slug(s.dataset.alt) === slug(color));
      const set = match.length ? match : allSlides;
      allSlides.forEach(s => (s.hidden = !set.includes(s)));
      thumbs.forEach(t => (t.hidden = !set.includes(allSlides[+t.dataset.thumb])));
      const dots = $(".dots", media);
      if (dots) dots.innerHTML = set.map((_, k) => `<i class="${k ? "" : "on"}"></i>`).join("");
      $$(".arrow", media).forEach(a => (a.hidden = set.length < 2));
      const thumbRow = $(".thumbs", pp);
      if (thumbRow) thumbRow.hidden = set.length < 2;
      show(media, 0);
    }

    function markThumb(i) {
      thumbs.filter(t => !t.hidden).forEach((t, k) => {
        t.classList.toggle("on", k === i);
        if (k === i) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current");
      });
    }
    if (media) media.addEventListener("slide", e => markThumb(e.detail));
    thumbs.forEach(t => t.addEventListener("click", () => show(media, thumbs.filter(x => !x.hidden).indexOf(t))));

    function refresh(changedColor) {
      const v = currentVariant();
      if (idInput) idInput.value = v.id;
      const price = $("[data-price]", pp);
      if (price) price.textContent = money(v.price);
      $$(".swatches", pp).forEach((f, k) => {
        const label = $("[data-option-label]", f);
        if (label) label.textContent = chosen()[k];
      });
      $$("[data-buy], [data-add-continue]", pp).forEach(b => (b.disabled = !v.available));
      const buy = $("[data-buy]", pp);
      if (buy) buy.textContent = v.available ? "Acheter" : "Épuisé";
      if (changedColor && colorIndex >= 0) filterMedia(chosen()[colorIndex]);
      const url = new URL(location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState(null, "", url.toString());
    }
    pp.addEventListener("change", e => {
      const f = e.target.closest(".swatches");
      if (f) refresh(+f.dataset.optionIndex === colorIndex);
    });
    if (colorIndex >= 0 && chosen()[colorIndex]) filterMedia(chosen()[colorIndex]);

    pp.addEventListener("click", e => {
      const step = e.target.closest("[data-qty]");
      if (step) {
        qty = Math.min(99, Math.max(1, qty + Number(step.dataset.qty)));
        $("[data-qty-value]", pp).textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      }
    });

    if (form) form.addEventListener("submit", async e => {
      e.preventDefault();
      const buy = e.submitter && e.submitter.hasAttribute("data-buy");
      try {
        await addToCart(idInput.value, qty);
        if (buy) { location.href = cartUrl; return; }
        const v = currentVariant();
        const label = product.variants.length > 1 ? ` (${v.title.toLowerCase()})` : "";
        toast(`Dans le panier : ${qty} × ${product.title}${label}`, { href: cartUrl, label: "Voir le panier" });
      } catch (err) {
        toast(err.message);
      }
    });

    // Photo agrandie
    const lightbox = $(".lightbox");
    if (lightbox) {
      let last = null;
      const close = () => {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        document.documentElement.style.overflow = "";
        if (last) last.focus();
      };
      pp.addEventListener("click", e => {
        const z = e.target.closest("[data-zoom]");
        if (!z || swiped) return;
        last = z;
        const img = $("img", lightbox);
        img.src = z.dataset.zoom;
        img.alt = product.title;
        lightbox.hidden = false;
        document.documentElement.style.overflow = "hidden";
        $(".lightbox-close", lightbox).focus();
      });
      lightbox.addEventListener("click", close);
      addEventListener("keydown", e => { if (e.key === "Escape") close(); });
    }
  }

  /* ---------- Page panier ---------- */
  const cartForm = $("[data-cart-form]");
  if (cartForm) {
    const update = $("[data-update]", cartForm);
    cartForm.addEventListener("click", e => {
      const step = e.target.closest("[data-step]");
      if (!step) return;
      const input = $("input", step.parentNode);
      input.value = Math.max(0, Number(input.value) + Number(step.dataset.step));
      cartForm.requestSubmit(update);
    });
    cartForm.addEventListener("change", e => {
      if (e.target.matches("[name='updates[]']")) cartForm.requestSubmit(update);
    });
    const agree = $("[data-agree]", cartForm), checkout = $("[data-checkout]", cartForm);
    if (agree && checkout) agree.addEventListener("change", () => (checkout.disabled = !agree.checked));
  }
})();
